import useEnvPropsStore from '~/stores/useEnvProps';
import type { EnvProps } from '~~/server/api/envProps';

// TODO use useEnvProps from store instead of this file
export function useEnvProps(): EnvProps {
  return useEnvPropsStore().envProps;
}

export default useEnvProps;
